import React from "react";
import { useGoodsModel } from "../materialModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useGoodsModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale,warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Material Management"]}</span>
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "配件编码",
            placeholder: Locale["Material Code"],
            fieldName: "code"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "配件名称",
            placeholder: Locale["Material Name"],
            fieldName: "name"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "替换编号",
            placeholder: Locale["Replace Code"],
            fieldName: "replaceCode"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "仓库名称",
            placeholder: Locale["Warehouse Name"],
            fieldName: "warehouseCode",
            options: transOptions(warehouseList)
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "状态",
            placeholder: Locale["Status"],
            fieldName: "enable",
            options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
        }
    ]
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}